import security from 'app/stores/security';
import API from 'utils/API';
import http from 'utils/http';

// 获取可出金金额
export function withdrawableCash({ profileId, bankCardId }) {
    return http
        .get<{
            withdrawable: number; // 可出金金额
        }>(API.TRADE.withdrawableCash(), {
            params: {
                // 如果profileId存在则不需要传bank_card_id
                bank_card_id: profileId ? undefined : bankCardId,
                profileId,
                account_id: security.currentAccountId,
                customer_id: security.currentCustomerId
            }
        })
        .then(({ data }) => data);
}
